import './App.scss';
import {Routes, Route} from 'react-router-dom';
import Layout from './components/Layout'
import Home from './components/Home'
import About from './components/About'
import Accolades from './components/Accolades'
import WorkExp from './components/WorkExp'
import Research from './components/Research'
import {Helmet} from "react-helmet";

function App() {
  return (
    <div>
        <Helmet>
          <title>Rohan S. Leekha</title>
          <meta name="description" content="Rohan Singh Leekha Portfolio - Machine Learning Engineer" />
        </Helmet>

      <Routes>
        <Route path="/" element={<Layout />}>
        <Route index element={<Home />}/>
        <Route path='/about' element={<About />}/>
        <Route path='/hackathons' element={<Accolades />}/>
        <Route path='/work-ex' element={<WorkExp />}/>
        <Route path='/research' element={<Research />}/>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
